// Reflection question icons are stored in Question.IconNames as an opaque,
// comma-separated string. A bare name is a Font Awesome Pro thin icon -- which is
// every icon written before emoji support -- and a "noto:" prefix selects a Noto
// emoji. Legacy rows therefore keep working untouched, with no migration.
//
// The prefix sits on each icon rather than on the list, because several callers do
// `iconNames.split(',').reverse()` to draw a scale high-to-low. A list-level prefix
// would end up on the wrong element after reversing.
//
// A 2-5 step scale keeps one entry per step and leaves it blank where the coach left the
// step out; scale-icons.ts has the helpers that read and write that shape.

export const NOTO_REF_PREFIX = 'noto:';

export type IconLibrary = 'fa' | 'noto';

export const iconLibraryOf = (ref: string | undefined | null): IconLibrary =>
  ref?.startsWith(NOTO_REF_PREFIX) ? 'noto' : 'fa';

export const isNotoRef = (ref: string | undefined | null): boolean => iconLibraryOf(ref) === 'noto';

/** Strips the library prefix, giving the name to look up in the Noto icon data. */
export const notoNameOf = (ref: string): string => ref.slice(NOTO_REF_PREFIX.length);

export const toNotoRef = (name: string): string => `${NOTO_REF_PREFIX}${name}`;
